import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';

import { FormSelect, OptionProps } from '@digital/ui';

import { getAllAreasByDiretoriaOptions } from '../../../../../api/area';
import {
  getAllDepartamentoProAreaIdOptions,
  getAllDepartamentoProDiretoriaIdOptions,
} from '../../../../../api/departamento';
import { getAllDiretoriasOptions } from '../../../../../api/diretoria';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';

interface IDadosRequisitanteFieldsProps {
  disabled?: boolean;
}

const OPCAO_NA: OptionProps = { text: 'N/A', value: 'na' };

function DadosRequisitanteFields({ disabled }: IDadosRequisitanteFieldsProps) {
  const {
    statusCodigo,
    diretoriaId,
    setDiretoriaId,
    areaId,
    setAreaId,
    departamentoId,
    setDepartamentoId,
    id,
  } = useContext(QuestionarioContextProvider);
  const [departamentos, setDepartamentos] = useState<OptionProps[]>();
  const [areas, setAreas] = useState<OptionProps[]>();

  useEffect(() => {
    setAreas([OPCAO_NA]);

    if (!diretoriaId) return;

    let cancelado = false;
    getAllAreasByDiretoriaOptions(diretoriaId).then(data => {
      if (!cancelado) setAreas([...data, OPCAO_NA]);
    });

    return () => {
      cancelado = true;
    };
  }, [diretoriaId]);

  // A Area manda: so quando nao ha Area selecionada a lista cai para a Diretoria.
  // Nunca as duas buscas ao mesmo tempo, senao a ultima a responder vence e a lista
  // muda conforme a ordem de selecao.
  useEffect(() => {
    setDepartamentos([OPCAO_NA]);

    const areaSelecionada = areaId && areaId !== 'na' ? areaId : undefined;
    if (!areaSelecionada && !diretoriaId) return;

    let cancelado = false;
    const buscaDepartamentos = areaSelecionada
      ? getAllDepartamentoProAreaIdOptions(areaSelecionada, true)
      : getAllDepartamentoProDiretoriaIdOptions(diretoriaId, true);

    buscaDepartamentos.then(data => {
      if (!cancelado) setDepartamentos([...data, OPCAO_NA]);
    });

    return () => {
      cancelado = true;
    };
  }, [diretoriaId, areaId]);

  const handleChangeDiretoria = (value: string) => {
    setDiretoriaId(value);
    setAreaId(undefined);
    setDepartamentoId(undefined);
  };

  const handleChangeArea = (value: string) => {
    setAreaId(value);
    setDepartamentoId(undefined);
  };

  return (
    <>
      <FormSelect
        id='mrn-select-diretoria'
        label="Diretoria"
        name="diretoriaId"
        placeholder="Selecione uma opção"
        getOptions={getAllDiretoriasOptions}
        value={diretoriaId}
        onChange={value => handleChangeDiretoria(value)}
        span={4}
        disabled={disabled || statusCodigo !== 1 && id !== null}
        required
        validateSchema={Yup.string().trim().required('Campo requerido.')}
      />
      <FormSelect
        id='mrn-select-area'
        label="Área"
        name="areaId"
        placeholder="Selecione uma opção"
        options={areas}
        span={4}
        value={areaId}
        onChange={value => handleChangeArea(value)}
        allowClear
        disabled={disabled || statusCodigo !== 1 && id !== null}
        required
        validateSchema={Yup.string().trim().required('Campo requerido.')}
      />

      {departamentos && (
        <FormSelect
          id='mrn-select-departamento'
          label="Departamento"
          name="departamentoId"
          placeholder="Selecione uma opção"
          options={departamentos}
          value={departamentoId}
          span={4}
          onChange={value => setDepartamentoId(value)}
          allowClear
          disabled={disabled || statusCodigo !== 1 && id !== null}
          required
          validateSchema={Yup.string().trim().required('Campo requerido.')}
        />
      )}
    </>
  );
}
export default DadosRequisitanteFields;
